export const SET_TOKEN = 'SET_TOKEN'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'
export const SET_ROOT_FIRM_PREFERENCES = 'SET_ROOT_FIRM_PREFERENCES'

export const SESSION_TOKEN_NAME = 'auth/token'
export const SESSION_USER_PROFILE = 'auth/profile'
export const SESSION_ROOT_FIRM_PREFERENCES = 'auth/rootFirmPreference'




// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js